import { Button } from '@/global/components/Button'
import ButtonGroup from '@/global/components/ButtonGroup'
import CalendarioMensal, {
    type EventoCalendario,
} from '@/global/components/CalendarioMensal'
import { Badge } from '@/global/components/ui/badge'
import dayjs from 'dayjs'
import { useCompetencia } from 'global/components/Selects/SelectCompetencia'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

interface IProps {
    value: ReturnType<typeof useCompetencia>[0]
    onChange: ReturnType<typeof useCompetencia>[1]
    datas: Date[]
}

export default function CalendarioAbonos({
    value: competencia,
    onChange,
    datas,
}: IProps) {
    const eventos: EventoCalendario[] = datas.map((it, index) => {
        const data = dayjs(it).format('YYYY-MM-DD')
        return {
            id: index.toString(),
            titulo: 'Abono',
            inicio: data,
            fim: data,
        }
    })

    const countEventsNextMonth = (() => {
            const n = eventos.filter(evento => {
                const eventDate = dayjs(evento.inicio)
                return eventDate.isAfter(dayjs(competencia).endOf('month'))
            }).length

            if (n > 99) return '+'
            return n
        })(),
        countEventsPastMonth = (() => {
            const n = eventos.filter(evento => {
                const eventDate = dayjs(evento.inicio)
                return eventDate.isBefore(dayjs(competencia).startOf('month'))
            }).length

            if (n > 99) return '+'
            return n
        })()

    return (
        <div className="size-full flex-1 min-h-0 flex flex-col overflow-hidden rounded-lg border">
            <div className="w-full h-fit border-b">
                <div className="inline-flex justify-between items-center overflow-x-auto gap-1 w-full p-2">
                    <div className="flex items-center gap-4 w-full">
                        <ButtonGroup className="*:relative *:h-10 *:aspect-1/1 *:min-w-0 *:p-2">
                            <Button
                                onClick={() =>
                                    onChange(prev =>
                                        dayjs(prev)
                                            .subtract(1, 'month')
                                            .format('YYYY-MM'),
                                    )
                                }
                                title="Mês anterior"
                                variant="outlined"
                            >
                                <Badge className="absolute top-0.5 right-0.5 size-5">
                                    {countEventsPastMonth}
                                </Badge>
                                <ChevronLeftIcon />
                            </Button>
                            <Button
                                onClick={() =>
                                    onChange(prev =>
                                        dayjs(prev)
                                            .add(1, 'month')
                                            .format('YYYY-MM'),
                                    )
                                }
                                title="Próximo mês"
                                variant="outlined"
                            >
                                <Badge className="absolute top-0.5 right-0.5 size-5">
                                    {countEventsNextMonth}
                                </Badge>
                                <ChevronRightIcon />
                            </Button>
                        </ButtonGroup>
                        <span className="text-lg font-semibold truncate select-none">
                            {dayjs(competencia)
                                .format('MMMM [de] YYYY')
                                .replace(/^[a-z]/, w => w.toUpperCase())}
                        </span>
                        <div className="flex flex-grow" />
                        <Button
                            variant="outlined"
                            disabled={dayjs(competencia, 'YYYY-MM').isSame(
                                dayjs(),
                                'month',
                            )}
                            onClick={() => onChange(dayjs().format('YYYY-MM'))}
                        >
                            Hoje
                        </Button>
                    </div>
                </div>
            </div>
            <CalendarioMensal competencia={competencia} eventos={eventos} />
        </div>
    )
}
